import React from 'react'
import { Heading } from 'components/util'

function Title (props) {
  const titleStyles = {
    barWidth: '87px',
    letterSpacing: '6px',
    mobileFontSize: '24px',
  }

  return (
    <Heading {...props}
      {...titleStyles}
      topBar={true}
      bottomBar={true}
    />
  )
}

export default Title
